import {Fill, Stroke, Style, Text} from "ol/style";
import Circle from "ol/style/Circle";

export const inventoryLocationStyle = (feature, overflow = null) => {
    let fill = new Fill({color: 'rgba(0, 200, 255, 0.1)'});
    let strokeColor = 'rgb(0, 200, 255)';

    if(/edit\/locations.*?\/(add|edit)/.test(window.location.href) && !feature.get('edited')) {
        fill = new Fill({color: 'rgb(91,136,145,0.1)'});
        strokeColor = 'rgb(91,136,145)';
    }

    return new Style({
        stroke: new Stroke({
            color: strokeColor,
            width: 2,
        }),
        fill,
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(0, 200, 255)', width: 1}),
            backgroundFill: new Fill({color: 'rgba(0, 0, 0, 0.1)'}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
}

export const inventoryLocationObserversLineStyle = (feature, overflow = null) => {
    return new Style({
        image: new Circle({
            fill: new Fill({
                color: 'rgb(26,255,0, 0.6)'
            }),
            stroke: new Stroke({
                color: 'rgba(38,171,5,0.8)'
            }),
            radius: 7
        }),
        stroke: new Stroke({
            color: 'rgb(26,255,0)',
            width: 2,
        }),
        fill: new Fill({color: 'rgba(6,82,0,0.71)'}),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(19,73,0)', width: 2}),
            backgroundFill: new Fill({color: 'rgba(0, 0, 0, 0.1)'}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
}

export const inventoryLocationBeatersLineStyle = (feature, overflow = null) => {
    return new Style({
        image: new Circle({
            fill: new Fill({
                color: 'rgba(255,152,0,0.6)'
            }),
            stroke: new Stroke({
                color: 'rgb(206,117,0)'
            }),
            radius: 8
        }),
        stroke: new Stroke({
            color: 'rgb(255,128,0)',
            width: 2,
        }),
        fill: new Fill({color: 'rgba(82,41,0,0.71)'}),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(80,45,0)', width: 2}),
            backgroundFill: new Fill({color: 'rgba(0, 0, 0, 0.1)'}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    });
}

export const farInventoryLocationStyle = () => {
    return new Style({
        stroke: new Stroke({
            color: 'rgb(0, 200, 255)',
            width: 2,
        }),
    })
}

export const drawInventoryLocationStyle = new Style({
    image: new Circle({
        fill: new Fill({
            color: 'rgb(255,207,34)'
        }),
        stroke: new Stroke({
            color: 'rgb(178,156,0)',
            width: 3
        }),
        radius: 5
    }),
    stroke: new Stroke({
        color: '#ffd300',
        width: 3
    }),
    fill: new Fill({
        color: 'rgba(255,231,0,0.23)'
    })
});
